import React from "react";
import CollapsibleContainer from '../components/collapsibleContainer';
import { useSelector } from 'react-redux';

import { FaInfo } from "react-icons/fa";

const Info = ()=>{
    const settings = useSelector(state=>state.data.data)

    return (
        <CollapsibleContainer open title="Info"  icon={<FaInfo />}>
          ARTIFEX (ARTistic Immersion for scientiFic EXploration) is an experimental platform for exploring Exoplanet data. Collapse the panels using the icon in the right corner, and rearrange the panels by dragging the title of each panel.

          
        </CollapsibleContainer>
        )
}

export default Info;